import React, { useState } from "react";
import "../../styles/special-deal.css";

export default function SpecialDeal() {
  const [brandName, setBrandName] = useState("");

  const benefits = [
    {
      icon: "bi bi-person-standing-dress",
      text: "6 pcs Kaos / Jersey (Desain bebas & sablon sesuai keinginan)",
    },
    { icon: "bi bi-tag", text: "Sablon Label Nama Brand" },
    { icon: "bi bi-file-earmark-text", text: "Washing Label / Tafeta Label" },
    { icon: "bi bi-box-seam", text: "Packaging (Ziplock / Plastik Klip)" },
    { icon: "bi bi-sticky", text: "Sticker Brand" },
    { icon: "bi bi-heart", text: "Thanks Card Eksklusif" },
    {
      icon: "bi bi-pencil",
      text: "FREE Editing Desain (Konsep dari customer)",
    },
    {
      icon: "bi bi-camera",
      text: "FREE Dokumentasi Produk (Siap konten & promosi)",
    },
    {
      icon: "bi bi-truck",
      text: "FREE ONGKIR Se-Pulau Jawa (Minimal pembelian 10 paket)",
    },
    {
      icon: "bi bi-chat-dots",
      text: "FREE Konsultasi Sepuasnya (Dari nol sampai brand siap jalan)",
    },
  ];

  const handleSendMessage = () => {
    if (brandName.trim() === "") {
      alert("Silakan masukkan nama brand Anda");
      return;
    }

    const message = `ORI_BUCB_${brandName}`;
    const whatsappUrl = `https://wa.me/62882003917166?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <section className="special-deal-section py-5" id="special-deal">
      <div className="container">
        <div className="row align-items-center g-4">
          {/* LEFT CONTENT */}
          <div className="col-lg-6" data-aos="fade-up">
            <span className="badge deal-badge mb-3 badge-lll">
              Special Deal For Clothing Brand Owner
            </span>

            <h2 className="deal-title">
              1X ORDER, <span>10 BENEFITS</span>
            </h2>

            <p className="deal-price">
              Mulai <strong>500 ribuan</strong> aja, kamu sudah bisa punya
              <strong> clothing brand sendiri</strong>.
            </p>

            <p className="deal-desc">
              Cocok banget buat kamu yang mau mulai brand tanpa ribet & tanpa
              modal besar!
            </p>

            <div className="deal-cta">
              <p className="fw-bold mb-1">PROMO TERBATAS!</p>
              <p className="small">
                Klaim sekarang dengan format:
                <br />
                <strong>ORI_BUCB_NAMA BRANDMU</strong>
              </p>

              <div className="input-with-icon mt-2">
                <input
                  type="text"
                  placeholder="Masukkan nama brand Anda"
                  value={brandName}
                  onChange={(e) => setBrandName(e.target.value)}
                  className="form-control styled-input"
                  aria-label="Nama brand"
                />
              </div>

              <button
                onClick={handleSendMessage}
                className="hero-section__btn claim-btn mt-2 w-100"
                aria-label="Klaim via WhatsApp"
              >
                <i className="bi bi-whatsapp me-2" /> Klaim via WhatsApp
              </button>

              <p className="text-mutedd small mt-2">
                ⚠️ Syarat & Ketentuan Berlaku
              </p>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <div className="benefit-box">
              <h5 className="mb-3 text-center">APA AJA YANG KAMU DAPAT?</h5>

              <ul className="benefit-list">
                {benefits.map((b, i) => (
                  <li key={i}>
                    <i
                      className={`benefit-icon ${b.icon}`}
                      aria-hidden="true"
                    />
                    <span className="benefit-text">
                      {b.text}
                      {b.text.includes("(Minimal pembelian") && <br />}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
